export { default as getCompactValue } from './getCompactValue';
